import {
  heroImageFromVinoDataOffer,
  largeHeroImageFromVinoDataOffer,
  relativeSizedHeroImageFromVinoDataOffer,
  wideHeroImageFromVinoDataOffer,
  roundelsImageFromVinoDataWineOffer,
} from "./images";

import { OfferDetailsSingleProps } from "../../components/offer-details";
import { VinoDataOffer } from "../../types/vino-data-types";
import { WineAttributesFromVinoDataWine } from "./wine-attributes";
import { awardsFromVinoDataWineSKU } from "./awards";
import { isFlagEnabled } from "../../utils/is-flag-enabled";
import { isSellableVinoDataWineSKU } from "./sku";
import { priceDescriptionFromVinoDataOffer } from "./price-description";
import { reviewsFromVinoDataWine } from "./reviews";
import { shouldShowDiscountBadge } from "./discount-badge";
import { tastingNotesFromVinoDataWine } from "./tasting-notes";
import { urgencyMessageFromVinoDataOffer } from "./urgency-message";
import { volumeFromVinoDataSKU } from "./volume";
import { bottleShapeFromVinoDataSKU } from "./shape";
import { generateStorefrontImage } from "../../utils/generate-storefront-image";

export const offerDetailsSinglePropsFromVinoDataOffer = (
  offer: VinoDataOffer
): OfferDetailsSingleProps => {
  const {
    bigcommerceId,
    discountPercentage,
    discountDollarValue,
    discountDisplay,
    displayFlags,
    description,
    videoUrl,
    videoCaption,
    shortDescription,
    region,
    style,
    sku,
    tagLine,
    subTagLine,
    name,
    bottomDescription,
    isSpirit,
    hasHeroImages,
  } = offer;
  const [wine] = sku.wines;
  const isSoldOut = !isSellableVinoDataWineSKU(sku);
  return {
    productId: bigcommerceId,
    awards: awardsFromVinoDataWineSKU(sku, 95),
    description,
    videoUrl,
    videoCaption,
    discountPercentage,
    discountDollarValue,
    discountDisplay,
    startsAt: offer.startsAt ? new Date(offer.startsAt) : undefined,
    endsAt: offer.endsAt ? new Date(offer.endsAt) : undefined,
    price: offer.displayPrice,
    priceDescription: priceDescriptionFromVinoDataOffer(offer),
    region,
    style,
    reviews: reviewsFromVinoDataWine(wine),
    unitRRP: sku?.unitRRP,
    packRRP: sku?.packRRP,
    shortDescription,
    showCountdown:
      isFlagEnabled(offer.displayFlags, "SHOW_COUNTDOWN") &&
      offer.endsAt !== undefined,
    showPriceDrop: isFlagEnabled(displayFlags, "SHOW_PRICEDROP"),
    showDiscountBadge: shouldShowDiscountBadge(offer),
    showAwardBadges: !isFlagEnabled(displayFlags, "HIDE_AWARDS_AND_RATINGS"),
    tastingNotes: tastingNotesFromVinoDataWine(wine),
    volume: volumeFromVinoDataSKU(sku),
    wineAttributes: WineAttributesFromVinoDataWine(wine),
    heroImage: heroImageFromVinoDataOffer(offer),
    cardImage: heroImageFromVinoDataOffer(offer),
    roundelsImage: roundelsImageFromVinoDataWineOffer(offer),
    relativeSizedHeroImage: relativeSizedHeroImageFromVinoDataOffer(offer),
    urgencyMessage: urgencyMessageFromVinoDataOffer(offer, isSoldOut),
    isSoldOut,
    tagLine,
    subTagLine,
    name,
    bottomDescription,
    isSpirit,
    bottleShape: bottleShapeFromVinoDataSKU(sku),
    bottleImage: hasHeroImages
      ? generateStorefrontImage(wine?.bottleImage, { height: 400 })
      : null,
    wideHeroImage: hasHeroImages ? wideHeroImageFromVinoDataOffer(offer) : null,
    largeHeroImage: hasHeroImages
      ? largeHeroImageFromVinoDataOffer(offer)
      : null,
    hasHeroImages: hasHeroImages,
  };
};
